import { getDomain } from "tldts";

function getRootDomainFallbacks(url: URL): string[] {
  const registrableDomain = getDomain(url.hostname);
  if (!registrableDomain || registrableDomain === url.hostname) {
    return [];
  }

  const rootDomainOrigin = `${url.protocol}//${registrableDomain}`;
  return [
    `${rootDomainOrigin}/favicon.ico`,
    `${rootDomainOrigin}/favicon/favicon.ico`,
  ];
}

function getRootDomainFaviconFallbacks(iconUrl: string): string[] {
  try {
    const url = new URL(iconUrl);
    if (!url.pathname.endsWith("/favicon.ico")) {
      return [];
    }

    return getRootDomainFallbacks(url);
  } catch {
    return [];
  }
}

export function getIconCandidates(
  icon: string | string[] | null | undefined
): string[] {
  if (Array.isArray(icon)) {
    return icon.filter(Boolean);
  }

  const rawCandidates = icon ? [icon] : [];

  const resolvedCandidates: string[] = [];

  for (const candidate of rawCandidates) {
    if (resolvedCandidates.includes(candidate)) {
      continue;
    }

    resolvedCandidates.push(candidate);

    const fallbackCandidates = getRootDomainFaviconFallbacks(candidate);
    for (const fallbackCandidate of fallbackCandidates) {
      if (!resolvedCandidates.includes(fallbackCandidate)) {
        resolvedCandidates.push(fallbackCandidate);
      }
    }
  }

  return resolvedCandidates;
}

export function getMcpFaviconUrls(serverUrl: string): string[] {
  try {
    const url = new URL(serverUrl);
    return getIconCandidates(`${url.origin}/favicon.ico`);
  } catch {
    return [];
  }
}

export function getMcpFaviconUrl(serverUrl: string): string | null {
  return getMcpFaviconUrls(serverUrl)[0] ?? null;
}
